import { Flex, Label } from "@jsq/ds/core";
import { FormCheckbox, FormPercentInput, useFormContext } from "@jsq/ds/forms";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ExtendedInfoTooltip } from "~/pages/Compliance/Common/ExtendedInfoTooltip";
import { useGuidedProfileCreation } from "~/pages/Compliance/flags";
import { FormValues } from "../../OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/CreateIndividualForm/types";
import RoleInfoBox from "../RoleInfoBox";
import { roleFieldsRow } from "./styles_vanilla.css";

const ProfileIndividualFormFields = ({
  isChildOfJointAccount = false,
  isOnboardingCase = false,
}: {
  isChildOfJointAccount?: boolean;
  isOnboardingCase?: boolean;
}) => {
  const { values } = useFormContext<FormValues>();
  const guidedProfileCreation = useGuidedProfileCreation();
  const useRoleLabel = guidedProfileCreation || isOnboardingCase;

  return (
    <>
      <Flex justifyContent="space-between" flexDirection="row" className={roleFieldsRow}>
        <Flex flexDirection="column" alignItems="flex-start">
          {useRoleLabel ? (
            <>
              <Flex alignItems="center" gap={Sizes.XS}>
                <Label>Role</Label>
                {isChildOfJointAccount && (
                  <ExtendedInfoTooltip message="This is a child profile of a joint ownership account type. Joint accounts are limited to the owner role and ownership percentage is not required.">
                    <Icon type="question-circle" variant="outline" color={Colors.Neutral600} />
                  </ExtendedInfoTooltip>
                )}
              </Flex>
              <FormCheckbox name="isOwner" label="Owner" disabled={isChildOfJointAccount} />
              <FormCheckbox
                name="isController"
                label="Controller"
                disabled={isChildOfJointAccount}
              />
            </>
          ) : (
            <>
              <Label>Role(s)</Label>
              <FormCheckbox name="isOwner" label="Owner"></FormCheckbox>
              <FormCheckbox name="isController" label="Controller"></FormCheckbox>
            </>
          )}
        </Flex>
        {values.isOwner === true && !isChildOfJointAccount && (
          <FormPercentInput label="Ownership percentage" name="ownershipPercentage" />
        )}
      </Flex>

      {!(guidedProfileCreation && isChildOfJointAccount) && <RoleInfoBox />}
    </>
  );
};

export default ProfileIndividualFormFields;
